import {LANGUAGES_AVAILABLE} from './i18.config';

export const scopeLoader = (importer: any, root = 'i18n') => {
  return LANGUAGES_AVAILABLE.reduce((acc: any, lang) => {
    acc[lang] = () => importer(lang, root);
    return acc;
  }, {});
};
